import { Injectable } from '@angular/core';
import { HttpRequest, HttpResponse, HttpHandler, HttpEvent, HttpInterceptor, HTTP_INTERCEPTORS } from '@angular/common/http';
import { Observable, of, throwError } from 'rxjs';
import { delay, mergeMap, materialize, dematerialize } from 'rxjs/operators';
import { environment } from '../../environments/environment';
declare var require: any;
@Injectable()
export class FakeBackendInterceptor implements HttpInterceptor {
    constructor() { }
    intercept(request: HttpRequest<any>, next: HttpHandler): Observable<HttpEvent<any>> {
        const testUser = { id: 1, username: 'test', password: environment.fakeBackendPwr , firstName: 'Test', lastName: 'User' };

        // wrap in delayed observable to simulate server api call
        return of(null).pipe(mergeMap(() => {
            if (environment.localhost) {
                if (request.url.match('api/v1/shp/config') && request.method === 'GET') {
                    return of(new HttpResponse({ status: 200, body: require('../_mocks/activecheck.json') }));
                }

                if(request.url.match('api/v1/shp/headerconfig') && request.method === 'GET') {
                    return of(new HttpResponse({ status: 200, body: require('../_mocks/header.json') }));
                }
                
                if(request.url.match('api/v1/shp/login') && request.method === 'GET') {
                    return of(new HttpResponse({ status: 200, body: require('../_mocks/login.json') }));
                }

                if(request.url.match('api/v1/shp/footerconfig') && request.method === 'GET') {
                    return of(new HttpResponse({ status: 200, body: require('../_mocks/footer.json') }));
                }

                if(request.url.match('/api/v1/1908/shp/kb/searchKbArticle') && request.method === 'POST') {
                    console.log("testing");
                    return of(new HttpResponse({ status: 200, body: require('../_mocks/searchresults.json') }));
                }
                // if(request.url.match('/api/v1/1571/shp/pwdResetConfig') && request.method === 'GET') {
                //     console.log("testing");
                //     return of(new HttpResponse({ status: 200, body: require('../_mocks/passwordreset.json') }));
                // }
            }
            // authenticate
            if (request.url.endsWith('/api/authenticate') && request.method === 'POST') {
                if (request.body.username === testUser.username && request.body.password === testUser.password) {
                    // if login details are valid return 200 OK with a fake jwt token
                    return of(new HttpResponse({ status: 200, body: { token: 'fake-jwt-token' } }));
                } else {
                    // else return 400 bad request
                    return throwError('Username or password is incorrect');
                }
            }

            // get users
            if (request.url.endsWith('/api/users') && request.method === 'GET') {
                // check for fake auth token in header and return users if valid, this security is implemented server side in a real application
                if (request.headers.get('Authorization') === 'Bearer fake-jwt-token') {
                    return of(new HttpResponse({ status: 200, body: [testUser] }));
                } else {
                    // return 401 not authorised if token is null or invalid
                    return throwError('Unauthorised');
                }
            }

            // pass through any requests not handled above
            return next.handle(request);

        }))

            // call materialize and dematerialize to ensure delay even if an error is thrown (https://github.com/Reactive-Extensions/RxJS/issues/648)
            .pipe(materialize())
            .pipe(delay(500))
            .pipe(dematerialize());
    }
}

export let fakeBackendProvider = {
    // use fake backend in place of Http service for backend-less development
    provide: HTTP_INTERCEPTORS,
    useClass: FakeBackendInterceptor,
    multi: true
};